<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div v-if="unauthorized">
                <h4>{{ $t('unauthorizedMessage')}}</h4>
            </div>
            <div v-else>
                <div class="form-group" v-if="!isLockedForEdit">
                    <div class="btn-group form-group">
                        <button class="btn btn-primary bg-primary text-white" id="addBtn1"
                                @click.stop="onCreateClick">
                            {{ $t('buttons.add.btnText')}}
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <hall-agenda ref="agendaGrid"
                                 :eventId="eventId"
                                 :showSettingsBtn="isLockedForEdit? false:true"
                                 :showBtns="isLockedForEdit? false:true"
                                 :showFilterBtn="showFilter"
                                 @editBtnClick="onEditClicked"
                                 @deleteBtnClick="onHallEventDelete"
                                 @detailsBtnClick="onDetailsBtnClick">
                    </hall-agenda>
                </div>

                <div class="card-deck mt-3">
                    <HallEventDeatilsCard v-for="item in source"
                                          :key="item.id"
                                          :value="item"
                                          :hideBtns="isLockedForEdit? true:false"
                                          :hideCloseBtn="true"
                                          :allowEdit="canCreateOrUpdateAgenda"
                                          :allowDelete="canDeleteAgenda"
                                          @onHallEventEdit="onEditClicked"
                                          @onHallEventDelete="onHallEventDelete">
                    </HallEventDeatilsCard>
                </div>
            </div>
        </div>

        <CreateModal :show="showCreate" v-if="!isLockedForEdit" :eventId="eventId" @onCreate="onCreate"
                     @onClose="onCreateClose"
                     @onDelete="onHallEventDelete"></CreateModal>
        <EditModal v-model="hallEventModel" v-if="!isLockedForEdit" :show="showEdit" @onClose="onEditClose"
                   @onSave="onHallEventEdit"
                   @onDelete="onHallEventDelete"></EditModal>

    </div>
</template>

<script>
    import HallAgenda from '@/components/scheduler/HallAgenda';
    import HallEventDeatilsCard from '@/components/scheduler/HallEventDetailsCard';
    import EditModal from '@/components/scheduler/edit.modal';
    import CreateModal from '@/components/scheduler/create.modal';
    import agendaService from '@/services/agenda.service';
    import { ScheduleTask } from '@/models/models';
    import { EventClaims } from '@/models/enums';


    export default {
        props: {
            eventId: {
                type: Number,
                required: true,
            },
            details: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            showFilter: {
                type: Boolean,
                default: true
            },
        },
        components: {
            HallAgenda,
            EditModal,
            CreateModal,
            HallEventDeatilsCard
        },
        data() {
            return {
                componentTitle: this.$t('scheduler.agenda'),
                loading: false,
                loaded: false,
                source: [],
                sortKey: '',
                sortOrders: {},
                filterKey: '',
                unauthorized: false,
                hallEventModel: null,
                showEdit: false,
                showCreate: false
            }
        },
        methods: {
            clearSource() {
                if (Array.isArray(this.source)) {
                    while (this.source.length > 0) {
                        this.source.pop();
                    }
                }
            },
            load() {
                this.clearSource();
                this.loading = true;

                agendaService
                    .loadForEvent(this.eventId)
                    .then(response => {
                        this.loading = false;

                        if (response.data.items && Array.isArray(response.data.items) && response.data.items.length > 0) {
                            response.data.items.forEach(item => {
                                this.source.push(new ScheduleTask(item));
                            });
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        let statusCode = this.$helpers.errorStatusCode(error);
                        if (statusCode === 403) {
                            this.accessDenied();
                            return;
                        }
                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            hallEventDeleted(item) {
                this.source = this.source.filter(function (i) {
                    return i.uid !== item.uid;
                });
            },
            hallEventSaved(item) {

            },
            accessDenied() {
                this.unauthorized = true;
            },
            onCreateClick() {
                if (this.details) {
                    return;
                }
                this.showCreate = true;
            },
            onEditClicked(item) {
                if (this.details) {
                    return;
                }

                agendaService
                    .getById(item.id)
                    .then(response => {
                        this.hallEventModel = response.data.model;
                        this.showEdit = true;
                    })
                    .catch(error => {
                        this.hallEventModel = null;
                        this.showEdit = false;

                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onDetailsBtnClick(item) {

            },
            onHallEventEdit() {
                this.hallEventModel = null;
                this.showEdit = false;
                this.refresh();
            },
            onCreateClose() {
                this.hallEventModel = null;
                this.showEdit = false;
                this.showCreate = false;
            },
            onEditClose() {
                this.hallEventModel = null;
                this.showEdit = false;
            },
            onCreate(model) {
                this.hallEventModel = null;
                this.source.push(new ScheduleTask(model));
                this.showEdit = false;
                this.refresh();
            },
            onHallEventDelete(item) {
                kendo.confirm(`${this.$t('scheduler.deleteConfirm')} '${item.title}'?`)
                    .then(function () {
                        this.doDelete(item);
                    }.bind(this));
            },
            doDelete(item) {
                agendaService
                    .delete(item.id)
                    .then(response => {
                        this.loading = false;

                        this.hallEventDeleted(item);
                        this.refresh();

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.loading = false;

                        let statusCode = this.$helpers.errorStatusCode(error);
                        if (statusCode === 403) {
                            this.accessDenied();
                            return;
                        }

                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            refresh() {
                let g = this.$refs.agendaGrid;
                if (g) {
                    g.refresh();
                }
                this.load();
            }
        },
        mounted() {
            this.load()
            this.sortOrders['id'] = 1;
            this.sortKey = 'id';

            this.loaded = true;
        },
        computed: {
            filteredData() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                var data = this.source.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
                return data;
            },
            canReadAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimReadRights(claim);
                return canRead || this.$store.getters.claims.agenda.read;
            },
            canCreateOrUpdateAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimCreateOrEditRights(claim);
                return canRead || this.$store.getters.claims.agenda.create;
            },
            canDeleteAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimDeleteRights(claim);
                return canRead || this.$store.getters.claims.agenda.delete;
            },
        }
    }
</script>

<style scoped>
</style>
